import { connect } from 'react-redux';
import bonusCardModule from 'app/store/bonuscard';
import BonusCard from './BonusCardInfo.component';

const { bonusCardInfoRequest } = bonusCardModule.actions;

const mapStateToProps = ({ bonuscard }) => ({
  content: bonuscard.bonusCardInfo
});

const mapDispatchToProps = {
  fetchContent: bonusCardInfoRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BonusCard);
